import { render, staticRenderFns } from "./OptimizerPro.vue?vue&type=template&id=6acfd468&"
import script from "./OptimizerPro.vue?vue&type=script&lang=js&"
export * from "./OptimizerPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports